import { Navigate, useLocation, useParams } from 'react-router';

// Keeps documented deep links and support links to /admin/track/:appId working.
// TODO: remove after 08-2027
export const ConnectionChartRedirect = () => {
  const { appId } = useParams();
  const { search } = useLocation();

  return <Navigate to={`/admin/connection-chart/${appId ?? ''}${search}`} replace />;
};
